import { View } from "@common/types/views/views";
import {
    AccrualMatchDefaultViewOptions,
    getDefaultAccrualMatchView,
} from "../accrualMatchView";
import { AccrualMatchColumn } from "../types";

/**
 * Same columns as the find-match step, plus the allocation-only Payment
 * column and a right-pinned close. Description stays in the shared set and
 * is editable on remaining rows.
 */
export function getDefaultAllocationView(
    options: AccrualMatchDefaultViewOptions,
): View {
    const matchView = getDefaultAccrualMatchView(options);
    return {
        ...matchView,
        columns: [
            ...matchView.columns.filter(
                (column) => column.id !== AccrualMatchColumn.ACTION,
            ),
            { id: AccrualMatchColumn.PAYMENT, options: { pin: "right" } },
            { id: AccrualMatchColumn.REMOVE, options: { pin: "right" } },
        ],
    };
}
